import React, { useMemo } from 'react';

import { Button } from 'antd';
import { MdOutlineEmail } from 'react-icons/md';
import { SiWhatsapp } from 'react-icons/si';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '../shared/hooks';
import { INCLUDED_SUPPORT_WIDGET_PATHS } from '../shared/utils';

// const supportWidgetStyle: React.CSSProperties = { width: 100, zIndex: 999 };

interface Props {}

const CustomerSupportWidget: React.FC<Props> = () => {
  const location = useLocation();

  const { hostMetadata } = useAppSelector((state) => state.app);

  const isSupportPage = useMemo(
    () => location.pathname === '/support',
    [location],
  );

  const isCommunityPage = useMemo(() => {
    return (
      location.pathname.includes('/community/channel') ||
      location.pathname.includes('/community/messages')
    );
  }, [location]);

  const openSupportMedium = () => {
    const supportType = hostMetadata?.supportWidget?.[0]?.type;
    const supportValue = hostMetadata?.supportWidget?.[0]?.value;

    if (!supportType || !supportValue) return;

    if (supportType === 'whatsapp') {
      window.open(supportValue);
    } else if (supportType === 'email') {
      window.location.href = `mailto:${supportValue}`;
    }
  };

  const supportIcon = useMemo(() => {
    if (hostMetadata?.supportWidget?.[0]?.type === 'whatsapp') {
      return <SiWhatsapp size={20} />;
    }

    return <MdOutlineEmail size={20} />;
  }, [hostMetadata]);

  if (
    !(
      hostMetadata?.enableSupportWidget &&
      hostMetadata?.supportWidget?.[0]?.type !== 'customScript' &&
      INCLUDED_SUPPORT_WIDGET_PATHS.some((path) =>
        location.pathname.includes(path),
      )
    ) ||
    isCommunityPage
  )
    return null;

  return (
    <Button
      type="primary"
      shape="circle"
      icon={supportIcon}
      style={{
        position: 'fixed',
        bottom: 100,
        right: 20,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        color: 'white',
      }}
      onClick={!isSupportPage ? openSupportMedium : undefined}
    />
  );
};

export default CustomerSupportWidget;
